import { Component } from '@angular/core';

import { DataLoaderService, CommonDataService, SummaryValidationService, SummaryService } from '../expert-service-call.index';
import { AlternateScreenComponent } from '../../alternate-options/alternate-options.component'
@Component({
  selector: 'expert-summary-validation',
  templateUrl: './expert-summary-validation.template.html',
  styleUrls: ['./expert-summary-validation.component.css'],
})
export class ExpertSummaryValidationComponent {
  private expertAddedMsgs: any;
  private expertDeletedMsgs: any;
  private expertAddedCodes: any;
  private expertDeletedCodes: any;
  private icon = "gray";
  private urlFlag: string;
  private errorMessage: string;

  constructor(private dataLoaderService: DataLoaderService, private alt: AlternateScreenComponent,
    private summaryValidationService: SummaryValidationService,
    private summaryService: SummaryService, private commonDataService: CommonDataService) {

  }
  ngOnInit() {

  }
  openSuccessMsg() {
    this.alt.removeCodesOnValidate(this.dataLoaderService.deletedCodes);
    this.submitData();
  }

  alternateOptionsForURLFlag2() {  
    if (this.dataLoaderService.flagDictionary.normalSummaryValidFlag || this.dataLoaderService.flagDictionary.expertSummaryValidFlag) {
      this.dataLoaderService.flagDictionary.expertSummaryValidFlag = false;
      this.dataLoaderService.flagDictionary.normalSummaryValidFlag = false;
    }
    this.dataLoaderService.flagDictionary.loadingFlag = true;
    this.dataLoaderService.flagDictionary.alternateOverlayFlag = true;
    let returnValidateResponse = this.summaryValidationService.getSummaryValidationData();
    returnValidateResponse.subscribe(
      validateResponse => {
        if (validateResponse.addedCodes.length > 0 || validateResponse.deletedCodes.length > 0) {
          this.dataLoaderService.addedCodes = validateResponse.addedCodes;
          this.dataLoaderService.addedMsgs = validateResponse.addedMsgs;
          this.dataLoaderService.deletedCodes = validateResponse.deletedCodes;
          this.dataLoaderService.deletedMsgs = validateResponse.deletedMsgs;
          this.dataLoaderService.flagDictionary.expertSummaryValidFlag = true;
          this.dataLoaderService.flagDictionary.normalSummaryValidFlag = true;
          this.dataLoaderService.flagDictionary.loadingFlag = false;
          this.commonDataService.sendSuggestion(validateResponse);
        }
        else {
          this.dataLoaderService.flagDictionary.alternateOverlayFlag = false;
          this.dataLoaderService.flagDictionary.loadingFlag = false;
          this.dataLoaderService.flagDictionary.summaryFlag = true;
          this.dataLoaderService.flagDictionary.successFlag = true;
          this.dataLoaderService.flagDictionary.expertSuccessFlag = true;
          this.dataLoaderService.flagDictionary.expertSummaryValidFlag = false;
          this.dataLoaderService.flagDictionary.normalSummaryValidFlag = false;
          //this.submitData();
        }
      },
      err => {
        if (err._body !== undefined) {
          this.errorMessage = err._body;
          this.commonDataService.notifyErrorMsgItem(this.errorMessage);
          this.dataLoaderService.flagDictionary.normalSummaryValidFlag = false;
          this.dataLoaderService.flagDictionary.expertSummaryValidFlag = false;
          this.dataLoaderService.flagDictionary.alternateErrorFlag = true;
          this.dataLoaderService.flagDictionary.loadingFlag = false;

        }
      }
    );
  }
  changeIcon() {
    if (this.icon == "gray") {
      this.icon = "blue";
    }
    else {
      this.icon = "gray";
    }
  }

  submitData() {
    let expertConfigData = this.summaryService.submitData();
    (<HTMLInputElement>document.getElementById('acceptString')).value = expertConfigData + '';
    (<HTMLFormElement>document.getElementById('form1')).action = this.dataLoaderService.vehicleInfo.hookURL + '';
    (<HTMLFormElement>document.getElementById('form1')).submit();
  }
}


// WEBPACK FOOTER //
// ./src/app/components/selectable-tabs/expert-screen-components/expert-summary-validation/expert-summary-validation.component.ts